import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

export default Swiper;

let clerk_mobile_slider;
let productsArray;
let product;

const fetchResponse = async () => {
  clerk_mobile_slider = document.querySelector('.clerk-side-cart');
  productsArray = JSON.parse(clerk_mobile_slider.dataset.products);
  product = parseInt(productsArray.map(Number).join(','));

  try {
    const response = await window.Clerk('call', 'recommendations/complementary', {
      attributes: ['id', 'handle'],
      limit: 12,
      products: [product],
      labels: ['sidecart/recommendations/complementary']
    });
    if (response.status !== 'ok') {
      throw new Error(
        `Could not fetch Clerk by endpoint: "${endpoint}". Server responded with: ${response.status}`,
      );
    }
    return response;
  } catch (error) {
    throw error;
  }
}

const fetchProduct = async ({ handle, id }) => {
  const result = await fetch(`/products/${handle}?view=view-drawer`);
  const html = await result.text();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  const productHtml = tempDiv.firstElementChild;
  const links = productHtml.querySelectorAll('a');

  links.forEach(link => {
    link.setAttribute('data-clerk-product-id', id);
  });

  return productHtml.outerHTML;
}

const getProducts = async (products) => {
  const promises = products.map(product => fetchProduct(product));
  return Promise.all(promises);
}

const initClerkSidecart = async () => {
  console.log(`Sidecart initialized`);

  if (!window.Clerk) {
    return;
  }

  try {
    const { product_data: products, result } = await fetchResponse();

    if (result.length === 0) {
      console.log('No results');
    }
    const productsHTML = await getProducts(products);
    clerk_mobile_slider.innerHTML = '';

    productsHTML.forEach((product) => {
      clerk_mobile_slider.insertAdjacentHTML(
        'beforeend',
        `${product}`,
      );
    });

    new Swiper('.clerk-sidecart-swiper', {
      "slidesPerView": 1.75,
      "navigation": {
        "nextEl": ".clerk-next-button",
        "prevEl": ".clerk-prev-button"
      },
      "spaceBetween": 5,
      "pagination": { 
        "el": ".clerk-pagination",
      },
      on: {
      init: function () {
        this.slides.forEach((slide, index) => {
          slide.setAttribute('data-swiper-slide-index', index);
        });
      },
      slideChange: function () {
        this.slides.forEach((slide, index) => {
          slide.setAttribute('data-swiper-slide-index', index);
        });
      }
    }
    });
    window.Clerk('click', '*[data-clerk-product-id]');
  } catch (error) {
    console.error(error);
  }
}

const open_sidecart = document.querySelector('body');

let cartFetched = false;
const config = { attributes: true };
const callback = async (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === "attributes") {  
      if (open_sidecart.classList.contains('open-cc') && !cartFetched) {
        cartFetched = true;
        initClerkSidecart();

        // Save the original fetch function
        const originalFetch = window.fetch;
        
        // Wrap fetch to listen for specific network calls
        window.fetch = async function (...args) {
          try {
            let url = '';
          
            // Check if the first argument is a string (URL) or a Request object
            if (typeof args[0] === 'string') {
              url = args[0];
            } else if (args[0] instanceof Request) {
              url = args[0].url;
            }
          
            // Log or handle URLs that include '/cart/change' or '/cart/add'
            if (url.includes('/cart/change') || url.includes('/cart/add')) {
              console.log('Intercepted fetch call to:', url);
              setTimeout(() => {
                initClerkSidecart();
              }, 3500);
            }
          
            // Call the original fetch function and return its result
            return originalFetch.apply(this, args);
          } catch (error) {
            console.error('Error in fetch interceptor:', error);
            throw error; // Re-throw the error to maintain fetch behavior
          }
        };
      }
    }
  }
};

const clerk_observer = new MutationObserver(callback);
clerk_observer.observe(open_sidecart, config);